import { LanguageActions, LanguageActionTypes } from '@dwo/actions';

export const initialState: LanguageState = {
  language: 'en',
};

export interface LanguageState {
  language: string;
}

export function languageReducer(state: LanguageState = initialState, action: LanguageActions): LanguageState {
  switch (action.type) {
    case LanguageActionTypes.changeLanguage:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
